<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          to="/"
        >
          <span class="brand-logo">
            <b-img
            style="width: 15%"
              :src="appLogoImage"
              alt="logo"
            />
          </span>
          <b-img
            :src="appNameLogo"
            alt="logo_text"
            class="brand-text mb-0"
          />
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appLogoImage, appNameLogo } = $themeConfig.app
    return {
      appLogoImage,
      appNameLogo,
    }
  },
}
</script>

<style>

</style>
